import styled, { css } from 'styled-components';
import Typography from '../typography/Typography';
import { CustomSelect as SelectView } from '../select/select-modal/styles';
import { CloseIcon } from '../assets';
import { TransparentButton } from '../transparent-button/TransparentButton';
export const CalendarWrapper = styled.div.attrs(({ ref }) => ({
    ref,
})) `
  position: absolute;
  left: 0;
  width: 100vw;
  max-width: 49.2rem;
  padding: 2rem 1.4rem;
  top: calc(100% - 5.4rem);
  z-index: ${({ theme }) => theme.zIndex.medium};
  box-shadow: ${({ theme }) => theme.shadows.xl2};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  background-color: ${({ theme }) => theme.colors.surface.default};

  cursor: default;
  display: none;
  ${({ theme }) => theme.media.tablet `
    display: block;
  `}

  .react-calendar__tile--rangeStart,
  .react-calendar__tile--rangeEnd,
  .react-calendar__tile--range,
  .react-calendar__tile--rangeStart abbr,
  .react-calendar__tile--rangeEnd abbr {
    ${({ hasDatesSelected }) => !hasDatesSelected &&
    css `
        background: transparent !important;
        color: ${({ theme }) => theme.colors.text.default} !important;
        &::after {
          background: transparent !important;
        }
      `};
  }
`;
export const LabelWrapper = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const DesktopLabel = styled(Typography) `
  display: none;
  ${({ theme }) => theme.media.tablet `
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`;
export const MobileLabel = styled(Typography) `
  display: block;
  color: ${({ theme }) => theme.colors.text.default};
  ${({ theme }) => theme.media.tablet `
    display: none;
  `}
`;
export const MobileFlex = styled(Typography) `
  display: flex;
  color: ${({ theme }) => theme.colors.text.default};
  ${({ theme }) => theme.media.tablet `
    display: none;
  `}
`;
export const IconWrapper = styled.div `
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;
  padding: 0 0.8rem;
  display: none;

  ${({ theme }) => theme.media.tablet `
    display: block;
  `}
`;
export const CustomSelectWrapper = styled.div `
  padding-left: 0;
  border: 1px solid ${({ theme }) => theme.colors.surface.tertiary};
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  ${({ theme }) => theme.media.tablet `
  padding-left: 0;
  border:none;
  background-color: transparent;
    padding: 0.5rem 1.8rem 0.5rem 0.8rem;
    width: 100%;
  `}
`;
export const CustomSelect = styled(SelectView) `
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.highL};

  padding-left: 0.8rem;
  border: 1px solid
    ${({ theme, isFiltered }) => isFiltered
    ? theme.colors.borders.highlight
    : theme.colors.borders.default};
  background-color: ${({ theme, isFiltered }) => isFiltered
    ? theme.colors.interactive.secondary
    : theme.colors.surface.tertiary};
  ${({ theme }) => {
    const backColor = theme.colors.surface
        .interactiveDefault;
    const radius = theme.borderRadius
        .mediumHigh;
    return theme.media.tablet `
        
        padding: 1rem 1.8rem;
        height: 5.4rem;

        margin-left:0;

        border-radius: ${radius};

        background-color:${backColor};

        svg{
          display:block;
        }
        padding: 0;
      `;
}};
`;
export const DialogWrapper = styled.div `
  padding: 2rem 1.4rem;
  display: block;
  ${({ theme }) => theme.media.tablet `
    display: none;
  `}
`;
export const DateIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  padding: 0.7rem;
  margin-right: 1.2rem;
`;
export const CustomImg = styled.img `
  width: 100%;
  object-fit: cover;
`;
export const CustomTransparentButton = styled(TransparentButton) `
  margin-left: 0.8rem;
`;
export const CustomCloseIcon = styled(CloseIcon) `
  width: 1rem;
  height: 1rem;
`;
//# sourceMappingURL=styles.js.map